// extracted by css-extract-rspack-plugin
export default {"breadcrumbsWrapper":"lQSnd","breadcrumbLastLabel":"khVRe","breadcrumbLinkLabel":"CGrkM","mainContentWrapper":"WgRI1"};